export const CONDITIONS_OPTIONS = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    value: 'FullTime',
    label: 'Full Time',
  },
  {
    value: 'PartTime',
    label: 'Part Time',
  },
  {
    value: 'SelfEmployed',
    label: 'Self Employed',
  },
  {
    value: 'Contract',
    label: 'Contract',
  },
  {
    value: 'Retired',
    label: 'Retired',
  },
  {
    value: 'Student',
    label: 'Student',
  },
  {
    value: 'Military',
    label: 'Military',
  },
  {
    value: 'Unemployed',
    label: 'Unemployed',
  },
  {
    value: 'Disabled',
    label: 'Disabled',
  },
];

export const ADDRESS_TYPE_OPTIONS = [
  {
    value: 'NotSet',
    label: 'Not Set',
  },
  {
    value: 'OwnsFreeClear',
    label: 'Owns Free & Clear',
  },
  {
    value: 'Rent',
    label: 'Rent',
  },
  {
    value: 'Parents',
    label: 'Parents',
  },
  {
    value: 'Military',
    label: 'Military',
  },
  {
    value: 'Mortgage',
    label: 'Mortgage',
  },
  {
    value: 'Lease',
    label: 'Lease',
  },
  {
    value: 'Boards',
    label: 'Boards',
  },
];

export const MARITAL_STATUS_OPTIONS = [
  {
    value: 'Unmarried',
    label: 'Unmarried',
  },
  {
    value: 'Married',
    label: 'Married',
  },
  {
    value: 'Separated',
    label: 'Separated',
  },
  //   {
  //     value: 'Divorced',
  //     label: 'Divorced',
  //   },
  {
    value: 'Widowed',
    label: 'Widowed',
  },
  //   {
  //     value: 'Other',
  //     label: 'Other',
  //   },
];
